import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddLeave from './sections/add';
import moment from 'moment';
import Swal from 'sweetalert2';

const AdminLeaves = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    
    const [leaves, setLeaves] = useState([]);
    const [selfLeaves, setSelfLeaves] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [filterText, setFilterText] = useState('');
    const [selStatus, setSelStatus] = useState('');
    const [selLeaveType, setSelLeaveType] = useState('');


    const fetchLeaves = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves?page=${currentPage + 1}`)
            .then(response => {
                setLeaves(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching leaves!", error);
                setLeaves([]);
            });

        axiosInstance.get(`${process.env.REACT_APP_API_URL}/selfLeaves?page=${currentPage + 1}`)
            .then(response => {
                setSelfLeaves(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching own leave records!", error);
                setSelfLeaves([]);
            });
    };

    useEffect(() => {
        fetchLeaves(currentPage);
    }, [currentPage]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = leaves.filter((item) => {
        var leaveType = selLeaveType;
        var status = selStatus;
        const matchesName = item.applicant_name.toLowerCase().includes(filterText.toLowerCase());
        const matchesLeaveType = leaveType ? item.leave_type === leaveType : true;
        const matchesStatus = status ? item.status === status : true;
        return matchesName && matchesLeaveType && matchesStatus;
    });

    const changeStatus = async ({leave_id, status}) => {
        let reason = null;

        if (status === '2') { // Check if status is '2' (Decline)
            const result = await Swal.fire({
                title: 'Are you sure decling the leave request?',
                icon: 'warning',
                input: 'textarea',
                inputPlaceholder: 'Enter reason here...',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                inputValidator: (value) => {
                    if (!value) {
                        return 'You need to provide a reason!';
                    }
                }
            });
    
            if (result.isConfirmed) {
                reason = result.value;
            } else {
                return; // If canceled, exit the function
            }
        }
        else{
            const isConfirm = await Swal.fire({
                title: 'Are you sure approving the leave request?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: `&nbsp;&nbsp;&nbsp; Yes &nbsp;&nbsp;&nbsp;`
            }).then((result) => {
                return result.isConfirmed
            });

            if(!isConfirm){
                return;
            }
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/leaves/${leave_id}`,{
                _method : 'patch',
                status: status,
                reason: reason
            })
            .then(({data})=>{
                Swal.fire({icon:"success",text:data.message});
                fetchLeaves();
            }).catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    };

    return (
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Leaves</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Leaves</li>
                            </ul>
                        </div>
                        {(userInfo.role_name !== 'Super-Admin') ? 
                            <div className="col-auto float-end ms-auto">
                                <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave">
                                    <i className="fa-solid fa-plus"></i> Add Leave</Link>
                            </div>
                            : <></>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Employee Name..." aria-label="Search Input"
                            value={filterText} onChange={(event) => {
                                setFilterText(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={selLeaveType}
                            onChange={(event) => { setSelLeaveType(event.target.value) }}>
                            <option value="">Select Leave Type</option>
                            <option value="Regular">Regular</option>
                            <option value="Regular S.L Time">Regular S.L Time</option>
                            <option value="Medical (Medical Certificate Required)">Medical (Medical Certificate Required)</option>
                            <option value="Medical S.L Time">Medical S.L Time</option>
                        </select>
                    </div>
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={selStatus}
                            onChange={(event) => { setSelStatus(event.target.value) }}>
                            <option value="">Select Status</option>
                            <option value="0">Pending</option>
                            <option value="1">Approved</option>
                            <option value="2">Declined</option>
                        </select>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <ul className="nav nav-pills nav-style-2 mb-3 border-bottom" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link className="nav-link active" data-bs-toggle="tab" role="tab" aria-current="page" to="#current"
                                    aria-selected="true">Employees - Active Leaves</Link>
                            </li>
                            <li className="nav-item" role="presentation">
                                <Link className="nav-link" data-bs-toggle="tab" role="tab" aria-current="page" to="#history"
                                    aria-selected="false" tabIndex="-1">Employees - Past Leaves</Link>
                            </li>

                            {(userInfo.role_name !== 'Super-Admin') ? 
                                <li className="nav-item" role="presentation">
                                    <Link className="nav-link" data-bs-toggle="tab" role="tab" aria-current="page" to="#selfLeaves"
                                        aria-selected="false" tabIndex="-1">Self Leaves</Link>
                                </li>
                                : <></>
                            }
                        </ul>

                        <div className="tab-content table-responsive">
                            <div id="current" className="tab-pane text-muted active show" role="tabpanel">
                                <table className="table table-striped custom-table">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Leave Type</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Reason</th>
                                            {(userInfo.role_name === 'Super-Admin') && <th>Manager/Team Lead</th> }
                                            <th className="text-center">Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            filteredItems.filter(item => !moment(item.to_date).isBefore(moment(), 'day')).length > 0 ? (
                                                filteredItems.filter(item => !moment(item.to_date).isBefore(moment(), 'day')).map((leave) => (
                                                    <tr key={leave.id}>
                                                        <td>
                                                            <h2>{leave.applicant_name} <span className="text-secondary">({leave.designation})</span> </h2>
                                                        </td>
                                                        <td>{leave.leave_type}</td>
                                                        <td>{leave.from_date} ({moment(leave.from_time, "HH:mm").format("hh:mm a")})</td>
                                                        <td>{leave.to_date} ({moment(leave.to_time, "HH:mm").format("hh:mm a")})</td>
                                                        <td className="leave-reason">{leave.reason}</td>
                                                        {(userInfo.role_name === 'Super-Admin') &&
                                                            <td>{leave.requested_to_name} <span className="text-secondary">({leave.requested_to_desgn})</span></td>
                                                        }
                                                        <td>
                                                            <div className="dropdown action-label text-center">
                                                                <Link className={`btn btn-white btn-sm btn-rounded dropdown-toggle ${leave.status === '0' ? 'dropdown-toggle' : ''}`}
                                                                    to="#" data-bs-toggle="dropdown" aria-expanded="false" title={leave.status === '2' ? leave.not_permitted_reason : ""}>
                                                                    {leave.status === '0' &&
                                                                        <><i className="fa-regular fa-circle-dot text-purple"></i> Pending</>
                                                                    }
                                                                    {leave.status === '1' &&
                                                                        <><i className="fa-regular fa-circle-dot text-success"></i> Approved</>
                                                                    }
                                                                    {leave.status === '2' &&
                                                                        <><i className="fa-regular fa-circle-dot text-danger"></i> Declined</>
                                                                    }
                                                                </Link>
                                                                {leave.status === '0' &&
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" onClick={() => changeStatus({ leave_id: leave.id, status: '1' })}>
                                                                            <i className="fa-regular fa-circle-dot text-success"></i> Approve
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => changeStatus({ leave_id: leave.id, status: '2' })}>
                                                                            <i className="fa-regular fa-circle-dot text-danger"></i> Decline
                                                                        </Link>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </td>                                                            
                                                        <td className="text-end">
                                                            {leave.status !== '0' &&
                                                                <>
                                                                    <Link className="btn btn-white btn-sm btn-rounded dropdown-toggle" to={leave.pdf_url || ''} target="_blank" rel="noopener noreferrer">                                                                        
                                                                        <i className="fa-regular fa-circle-dot text-info"></i> View Leave Form
                                                                    </Link>
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="text-center" colSpan={(userInfo.role_name === 'Super-Admin') ? "8" : "7"}>No leaves found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div id="history" className="tab-pane text-muted" role="tabpanel">
                                <table className="table table-striped custom-table">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Leave Type</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Reason</th>
                                            {(userInfo.role_name === 'Super-Admin') && <th>Manager/Team Lead</th> }
                                            <th className="text-center">Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            filteredItems.filter(item => moment(item.to_date).isBefore(moment(), 'day')).length > 0 ? (
                                                filteredItems.filter(item => moment(item.to_date).isBefore(moment(), 'day')).map((leave) => (
                                                    <tr key={leave.id}>
                                                        <td>
                                                            <h2>{leave.applicant_name} <span className="text-secondary">({leave.designation})</span> </h2>
                                                        </td>
                                                        <td>{leave.leave_type}</td>
                                                        <td>{leave.from_date} ({moment(leave.from_time, "HH:mm").format("hh:mm a")})</td>
                                                        <td>{leave.to_date} ({moment(leave.to_time, "HH:mm").format("hh:mm a")})</td>
                                                        <td className="leave-reason">{leave.reason}</td>
                                                        {(userInfo.role_name === 'Super-Admin') &&
                                                            <td>{leave.requested_to_name} <span className="text-secondary">({leave.requested_to_desgn})</span></td>
                                                        }
                                                        <td>
                                                            <div className="dropdown action-label text-center">
                                                                <Link className={`btn btn-white btn-sm btn-rounded dropdown-toggle ${leave.status === '0' ? 'dropdown-toggle' : ''}`}
                                                                    to="#" data-bs-toggle="dropdown" aria-expanded="false" title={leave.status === '2' ? leave.not_permitted_reason : ""}>
                                                                    {leave.status === '0' &&
                                                                        <><i className="fa-regular fa-circle-dot text-purple"></i> Pending</>
                                                                    }
                                                                    {leave.status === '1' &&
                                                                        <><i className="fa-regular fa-circle-dot text-success"></i> Approved</>
                                                                    }
                                                                    {leave.status === '2' &&
                                                                        <><i className="fa-regular fa-circle-dot text-danger"></i> Declined</>
                                                                    }
                                                                </Link>
                                                                {leave.status === '0' &&
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" onClick={() => changeStatus({ leave_id: leave.id, status: '1' })}>
                                                                            <i className="fa-regular fa-circle-dot text-success"></i> Approve
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => changeStatus({ leave_id: leave.id, status: '2' })}>
                                                                            <i className="fa-regular fa-circle-dot text-danger"></i> Decline
                                                                        </Link>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </td>                                                            
                                                        <td className="text-end">
                                                            {leave.status !== '0' &&
                                                                <>
                                                                    <Link className="btn btn-white btn-sm btn-rounded dropdown-toggle" to={leave.pdf_url || ''} target="_blank" rel="noopener noreferrer">                                                                        
                                                                        <i className="fa-regular fa-circle-dot text-info"></i> View Leave Form
                                                                    </Link>
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="text-center" colSpan={(userInfo.role_name === 'Super-Admin') ? "8" : "7"}>No leaves found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {(userInfo.role_name !== 'Super-Admin') ? 
                                <div id="selfLeaves" className="tab-pane text-muted" role="tabpanel">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Leave Type</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Reason</th>
                                                <th>Approved By</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                selfLeaves.length > 0 ? (
                                                    selfLeaves.map((leave) => (
                                                        <tr key={leave.id}>
                                                            <td>{leave.leave_type}</td>
                                                            <td>{leave.from_date} ({moment(leave.from_time, "HH:mm").format("hh:mm a")})</td>
                                                            <td>{leave.to_date} ({moment(leave.to_time, "HH:mm").format("hh:mm a")})</td>
                                                            <td className="leave-reason">{leave.reason}</td>
                                                            <td>{leave.requested_to_name}</td>
                                                            <td>
                                                                <div className="action-label">
                                                                    <div className="btn btn-white btn-sm btn-rounded" title={leave.status === '2' ? leave.not_permitted_reason : ""}>
                                                                        {leave.status === '0' &&
                                                                            <><i className="fa-regular fa-circle-dot text-purple"></i> Pending</>
                                                                        }
                                                                        {leave.status === '1' &&
                                                                            <><i className="fa-regular fa-circle-dot text-success"></i> Approved</>
                                                                        }
                                                                        {leave.status === '2' &&
                                                                            <><i className="fa-regular fa-circle-dot text-danger"></i> Declined</>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                : <></>
                            }

                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
            </div>

            <AddLeave list={fetchLeaves} />
        </>
    );
}

export default AdminLeaves